// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hJKM{flex-grow:1;text-align:center}.q5\\+9{margin-bottom:16px;margin-top:0}._4oQ8{margin-top:24px}.\\+Iey{color:#fa5f84}.\\+Iey:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registration": "hJKM",
	"title": "q5+9",
	"btn": "_4oQ8",
	"error": "+Iey"
};
module.exports = ___CSS_LOADER_EXPORT___;
